import { useSentry } from '@/js/hooks/sentry.hook'
import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  ...useSentry({})
})
